import React from 'react';
import classNames from 'classnames';

import Button from 'components/partials/button/button';

export interface ActionMenuItemProps {
  label: string;
  icon?: React.ReactNode;
  isDelete?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  hideDropdownCallback?: () => void;
}

const ActionMenuItem = ({
  label,
  icon,
  isDelete,
  onClick,
  disabled,
  hideDropdownCallback: _hideDropdownCallback,
}: ActionMenuItemProps): React.JSX.Element => (
  <Button
    className={classNames(
      'action-menu-item text-gray-600 font-normal hover:text-gray-600 hover:bg-navy-50 duration-500 pr-0 pl-2 !justify-start w-full',
      {
        '!text-critical-500 hover:text-critical-500': isDelete,
      }
    )}
    variant="reserve-text"
    iconBefore={icon}
    onClick={onClick}
    disabled={disabled}
    data-testid={`action-menu-item-${label.toLowerCase().replace(' ', '-')}`}
  >
    {label}
  </Button>
);

export default ActionMenuItem;
